import React from 'react';

const presets = [5, 10, 25, 50, 100];

export default function StakeInput({ value, onChange, balance }) {
  const isInsufficient = value > balance;
  const isBelowMin = value < 1;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2">
        <span className="text-[#B0B0B0] text-sm">💰 Stake:</span>
        <input
          type="number"
          min="1"
          max="1000"
          step="1"
          value={value}
          onChange={(e) => onChange(parseFloat(e.target.value) || 0)}
          className={`flex-1 h-14 bg-[#121212] rounded-lg border px-3 font-mono text-white text-lg outline-none ${isInsufficient ? 'border-[#FF5252]' : isBelowMin ? 'border-[#FFD740]' : 'border-[#333] focus:border-[#00E676]'}`}
        />
        <span className="text-[#B0B0B0] text-sm">USDT</span>
      </div>
      {isInsufficient && <p className="text-[#FF5252] text-xs">Saldo insuficiente</p>}
      {isBelowMin && <p className="text-[#FFD740] text-xs">Mínimo $1</p>}
      <div className="flex gap-2 overflow-x-auto">
        {presets.map((p) => (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={`px-3 py-2 rounded-lg text-xs font-bold whitespace-nowrap ${value === p ? 'bg-[#00E676] text-[#121212]' : 'bg-[#2C2C2C] text-[#B0B0B0]'}`}
          >
            {p}
          </button>
        ))}
        <button
          onClick={() => onChange(Math.min(balance, 1000))}
          className="px-3 py-2 rounded-lg text-xs font-bold whitespace-nowrap bg-[#2C2C2C] text-[#B0B0B0]"
        >
          MAX
        </button>
      </div>
    </div>
  );
}
